
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HintComponent } from '@shared-angular/components/hint/hint.component';
import { BotLocale, LocalizedBotText } from '@shared/index';
import { BotService } from 'src/app/shared/services/bot.service';
import { BOT_LOCALE_OPTIONS } from 'src/app/shared/constants/bot-locale-options';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { CodemirrorAiComponent } from "../../../../../../shared/components/ai-bot/utils/codemirror-ai/codemirror-ai.component";
import { ManualLinkComponent } from "../../../../../../shared/components/rag-admin/manual-link/manual-link.component";
import { FormForBooleanComponent } from 'src/app/shared/components/ai-bot/utils/form-for-boolean/form-for-boolean.component';
import { BotHistoryCleanupComponent } from './bot-history-cleanup/bot-history-cleanup.component';
import { BotWordReplaceComponent } from './bot-word-replace/bot-word-replace.component';
import { BotWordStopComponent } from './bot-word-stop/bot-word-stop.component';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TabsModule } from 'primeng/tabs';
import { Textarea } from 'primeng/textarea';

@Component({
  imports: [
    FormsModule,
    HintComponent,
    BotWordStopComponent,
    BotWordReplaceComponent,
    BotHistoryCleanupComponent,
    ManualLinkComponent,
    FormForBooleanComponent,
    CodemirrorAiComponent,
    CardModule,
    ButtonModule,
    InputTextModule,
    TabsModule,
    Textarea
  ],
  templateUrl: './privacy-policy-tab.component.html',
  styleUrl: './privacy-policy-tab.component.scss'
})
export class PrivacyPolicyTabComponent implements OnInit {
  protected readonly localeOptions = BOT_LOCALE_OPTIONS;
  protected selectedComplianceLocale: BotLocale = 'de';
  protected selectedStorageAccessLocale: BotLocale = 'de';
  protected readonly deleteGuestsAfterNotice = $localize`:@@delete-guests-after-notice:Nicht eingeloggte Gästedaten löschen nach X Tagen:`;

  constructor(private bot: BotService, public rss: RouteShareService) { }

  // Ältere Bots (vor dem Multi-Sprachen-Umbau bzw. ohne durchgelaufene DB-Migration) liefern
  // complianceText/storageaccessText noch als einzelnen String oder undefined statt als Map.
  public ngOnInit(): void {
    this.rss.botConfig.complianceText = this.normalizeLocalizedText(this.rss.botConfig.complianceText);
    this.rss.botConfig.storageaccessText = this.normalizeLocalizedText(this.rss.botConfig.storageaccessText);
  }

  private normalizeLocalizedText(value: unknown): LocalizedBotText {
    if (value == null) return {};
    if (typeof value === 'string') return value === '' ? {} : { de: value };
    return value;
  }

  public async reset() {
    this.rss.botConfig.complianceText[this.selectedComplianceLocale] = await this.bot.getDefaultComplianceText(this.selectedComplianceLocale);
    void this.rss.saveBotConfigField('complianceText');
  }

  public deleteText() {
    this.rss.botConfig.complianceText[this.selectedComplianceLocale] = '';
    void this.rss.saveBotConfigField('complianceText');
  }

  public onDeleteGuestsAfterDaysToggle(enabled: boolean): void {
    this.rss.botConfig.deleteGuestsAfterDays = enabled ? 1 : -1;
    void this.rss.saveBotConfigField('deleteGuestsAfterDays');
  }
}